import { Core } from "@faire/design-tokens";
import {
  loadingStateCss,
  pageMaxWidthCss,
} from "@faire/help-center/components/Mixin";
import {
  DESKTOP_GUTTER_SIZE,
  TABLET_GUTTER_SIZE,
} from "@faire/help-center/consts";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web--source/slate/Typography";
import styled from "styled-components";

export const SectionWrapper = styled.div<{ $isLoading?: boolean }>`
  ${pageMaxWidthCss}
  padding:${TABLET_GUTTER_SIZE}px;
  padding-bottom: 0px;
  position: relative;

  ${responsiveMediaQueries.tabletAndAbove} {
    padding-left: 0;
    padding-bottom: 2px;
  }

  ${responsiveMediaQueries.desktopAndAbove} {
    padding-left: 0;
    padding-bottom: 18px;
  }

  &:last-child {
    padding-bottom: 0px;
  }

  &:after {
    display: block;
    position: absolute;
    bottom: 0;
    left: 0;
    content: "";
    width: 100%;
    height: 1px;
    padding: 0px;
    background-color: ${Core.surface.subdued};

    ${responsiveMediaQueries.tabletAndAbove} {
      left: ${TABLET_GUTTER_SIZE}px;
      width: calc(100% - ${TABLET_GUTTER_SIZE * 2}px);
    }

    ${responsiveMediaQueries.desktopAndAbove} {
      left: ${DESKTOP_GUTTER_SIZE}px;
      width: calc(100% - ${DESKTOP_GUTTER_SIZE * 2}px);
    }
  }

  ${loadingStateCss}
`;

export const SectionHeader = styled(Typography).attrs({
  variant: "displaySSerifRegular",
})`
  &&& {
    padding-left: 0;
    ${responsiveMediaQueries.tabletAndAbove} {
      padding-left: 40px;
    }

    ${responsiveMediaQueries.desktopAndAbove} {
      padding-left: ${DESKTOP_GUTTER_SIZE}px;
    }
  }
`;
